import { useContext, useEffect } from 'react';
import Input from '../helper/Input';
import { FormContext } from '../helper/Form';

function ActiveCampaign({ activeCampaigntagId }) {
	const prefix = `_activeCampaignTagIds.act_${activeCampaigntagId}`;
	const formState = useContext(FormContext);

	useEffect(() => {
		return () => formState.setField(prefix, undefined);
	}, []);

	return <Input type="hidden" name={`${prefix}`} value={activeCampaigntagId} />;
}
export default ActiveCampaign;
